// extracted by mini-css-extract-plugin
export default {"productGrid":"zZ-z","centerLink":"AZ-z","productSection":"BZ-z","item":"CZ-z","ctaButton":"DZ-z"};